/**
 * @generated SignedSource<<566a17e13c25b8fbf69a7a767a09211c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
import { FragmentRefs } from "relay-runtime";
export type NoteSettings_Note$data = {
  readonly id: string;
  readonly noteSize: WidgetNoteSize;
  readonly pages: ReadonlyArray<{
    readonly id: string;
    readonly includedInSlideshow: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetNotePage_widgetNotePage">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "NoteSettings_Note";
};
export type NoteSettings_Note$key = {
  readonly " $data"?: NoteSettings_Note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteSettings_Note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteSettings_Note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noteSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetNotePage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "includedInSlideshow",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetNotePage_widgetNotePage"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "02d1dc5a2ce762753136a42c179e1e57";

export default node;
